import {
  Box,
  Grid,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { NewUseStore } from "../../../../Store/newUseStore";
import MeetingCard from "../../../Meeting/MeetingCard/MeetingCard";
import { baseUrl } from "../../../../env";
import EditMeeting from "../../../Meeting/LComponents/Forms/EditMeeting/EditMeeting";
import { useGetAllMeetings, UseGetWebCheckinMeetingDetailsByMeetingId } from "../../../Meeting/Hooks";
import { EditKeyResult } from "../../../OKRManagment/Forms/EditKeyResult/EditKeyResult";
import OKRsSlider from "../OKRsSlider/OKRsSlider";
import EditObjective from "../../../OKRManagment/Forms/EditObjective/EditObjective";
import OSlider from "../OKRsSlider/OSlider";
import { Swiper, SwiperSlide } from "swiper/react";
import GaugeChart from "./GaugeChart";
import { useGetAllCooperateByPersonId, useGetMyKeyResultByTenantId,
  useGetMyObjectiveByTenantId
 } from '../../Hooks/index';
import "swiper/swiper-bundle.min.css"; 
import DYToastMessage from '../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';
import ModalLyt from "../../../../components/Layouts/ModalLyt/ModalLyt";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useGetAllPersonPictureByTenantId } from '../../../AllTenantOkrs/Hooks';
import LoadingSpinner from '../../../../components/Progress/LoadingSpinner';
import { useEffect, useState } from "react";
import CoopSlider from "../OKRsSlider/CoopSlider";
import SubAlignmentKrCart from "../../../CompanyTeams/LComponents/SubAlignmentKrCart/SubAlignmentKrCart";
import OCart from "../../../OKRManagment/LComponents/OCart/OCart";
import OKRsCart from "../../../OKRManagment/LComponents/OKRsCart/OKRsCart";

const AllTenantDash = (props:any) => {

  const updateNewCompanyId = NewUseStore((state) => state.updateNewCompanyId);
  const [meetId, setMeetId] = useState<any>("");
  const [createTenantModal, setCreateTenantModal] = useState<boolean>(false);
  const [showToastMessage2, setShowToastMessage2] = useState<boolean>(false);
  const profileTenantId = NewUseStore((state) => state.newTenantId);
  const [isGridView, setIsGridView] = useState(true); // حالت نمای شبکه‌ای
  
  let{obj,periodId,dashBoardData,periodsData,afterSuccess}=props;
    const[allObjective,setAllObjective]=useState<any[]>()
    const tenantId:string=useSelector((state:any)=>state.meetings.profileTenantId);
    const[allKeyResult,setAllKeyresult]=useState<any[]>();
    const{data:personPicture,isLoading:loadingg}=useGetAllPersonPictureByTenantId(tenantId);
    const label1 = 'درصد ارزیابی من در جلسه آخر';
    const label2 = 'درصد امتیاز من در جلسه آخر';
    const sections = [
      { value: 30, color: '#fbd6d0', name: ' ۰ تا ۳۰' }, // 0 تا 30
      { value: 40, color: '#f7e59b', name: ' ۳۰ تا ۷۰' }, // 30 تا 70
      { value: 30, color: '#a0e6a0', name: ' ۷۰ تا ۱۰۰' }, // 70 تا 100
    ];
    const[showToastMessage,setShowToastMessage]=useState<boolean>(false);
    const [showAddObjective, setShowAddObjective] = useState<boolean>(false);
    const{data:objetcideData,isLoading:getObjectiveLoading,isError,refetch:getObjectivesAgain}
        =useGetMyObjectiveByTenantId(periodId,tenantId);
    const{data:keyresultData,isLoading:getKeyresultLoading,refetch:getObjDataAgain}
        =useGetMyKeyResultByTenantId(periodId,tenantId);
    const{data:CooperateData,isLoading:CooperateLoading,refetch:getCooperateAgain}
         =useGetAllCooperateByPersonId(periodId,tenantId);
    const [meetingAsyncState, setMeetingAsyncState] = useState<any | null>(null);
      const [krId, setKrId] = useState<any>();
      const [Item, setIteam] = useState<any>();
      const[showEditKr,setShowEditKr]=useState<boolean>(false);
    const[showEditObjective,setShowEditObjective]=useState<Boolean|null>(false);
    const[objectiveAsynOpcState,setObjectiveAsyncOpState]=useState<any>(null);
    const dispatch=useDispatch()
    const [objectiveId,setObjectiveId]=useState<string|null>(null);
    const [showDownloadLink, setShowDownlodLink] = useState<boolean>(false);
    const[tenantRemainLicense,setTenantRemainLicense]=useState<any>(null);
    const [showToastMessage3, setShowToastMessage3] = useState<boolean>(false);
    const[addKrState,setAddKrState]=useState<any>(null);

    const onSuccesss=():void=>{
      navigate('/dashboard/meetings',{replace:true})
    }
    
    const onFailed=():void=>{
    
    }
    
      useEffect(() => {
        if (krId) {
          setShowEditKr(true)
        }
         
        }, [krId])

  const initialAddObjective = (): void => {
    setShowAddObjective(prev => !prev)
  }
  const isLoading = getObjectiveLoading || getKeyresultLoading;

  useEffect(() => {
    setAllObjective(objetcideData);
  }, [objetcideData]);

  useEffect(() => {
    setAllKeyresult(keyresultData);
  }, [keyresultData]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (dashBoardData) {
      setTenantRemainLicense(dashBoardData?.licenseDaysRemain);
      setLoading(false); // تغییر حالت بارگذاری به false بعد از دریافت داده
    }
  }, [dashBoardData]);

  const navigate = useNavigate();
  const getDetSuccess = (data: any) => {
    if (
      (data &&
        data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos &&
        data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos.length >
          0) ||
      (data.webTeamWithoutParentCheckinMeetingDetailsQueryResultDtos &&
        data.webTeamWithoutParentCheckinMeetingDetailsQueryResultDtos.length >
          0)
    ) {
      const id =
        data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos &&
        data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos.length > 0
          ? data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos[0].id
          : data.webTeamWithoutParentCheckinMeetingDetailsQueryResultDtos[0].id;
      updateNewCompanyId(id);
      navigate("/companyTeams");
    } else {
      setMeetingAsyncState({
        isSuccess: false,
        metaData: { message: "اطلاعاتی برای نمایش وجود ندارد" },
      });
      setShowToastMessage(true);
    }
  };
  const getDetFailed = () => {};
  const {
    data: MeetDetData,
    isLoading: meetLoading,
    refetch: getAgain,
  } = UseGetWebCheckinMeetingDetailsByMeetingId(
    getDetSuccess,
    getDetFailed,
    meetId
  );

  const userPhoneNumber: string = useSelector(
    (state: any) => state.loign.userPhoneNumber
  );

  const {
    isLoading: meetLoadin,
    data: meetdata,
    isFetched,
    refetch: getAgain1,
  } = useGetAllMeetings({
    tenantId: profileTenantId,
    priodId: periodId,
    userPhoneNumber: userPhoneNumber,
  });

  const [existData, setExistData] = useState<any>(null);
  const [accessForReport, setAccessForReport] = useState<boolean>(false);
  const [meetingLenght, setMeetingLenght] = useState<Number>(0);
  // const [reloadMeetingData, setReloadMeetingData] = useState<boolean>(false);
  const [bank,setBank]=useState<boolean>(false);
  const [showEditMeeting, setshowEditMeeting] = useState<boolean>(false);
  const [meetingId, setMeetingId] = useState<string | null>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); 

  useEffect(() => {
    if (meetdata) {
      let { accessibleForReport, meetingsList } = meetdata;
      setAccessForReport(accessibleForReport);
      setExistData(meetingsList);
      setMeetingLenght(meetingsList.length);
    }
  }, [meetdata]);

  
  useEffect(() => {
    if (meetdata) {
      let{bank}=meetdata;
      setBank(bank)
    }
  },[meetdata]);

  const initialCreateMeeting = () => {
    setCreateTenantModal(!createTenantModal);
  };

  if (loading || isLoading || meetLoadin || meetLoadin || existData===null || isFetched!==true || CooperateLoading) {
    return <Box width={'100%'} height={'100vh'} display="flex" justifyContent="center" alignItems="center">
            <LoadingSpinner />
          </Box>
   }

  return (
    <Grid container spacing={1} px={2}>
    <Grid container>
    <Grid item xs={12} >
    <Grid item xs={12} >
    <Box display={'flex'}   justifyContent={'space-around'} marginTop={2}>
    <Box display={'flex'}    flexDirection={'column'}  >
    </Box>
    </Box>
    </Grid>

    <Grid item xs={12}>
    {tenantRemainLicense <= 30 && (
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Box
          display={'flex'}
          bgcolor='#E5F1FF'
          padding={1.5}
          borderRadius={8}
          boxShadow={3}
          flexDirection={'column'}
          textAlign={'center'}
          maxWidth={300} 
        >
          <Typography
            color={tenantRemainLicense < 6 ? '#d32f2f' : '#000000'}
            variant='h4'
            fontSize={'12px'}
            fontWeight={600}
            marginBottom={1}
          >
            تعداد روزهای باقی مانده قرارداد:
          </Typography>
          <Typography
            color={tenantRemainLicense < 6 ? '#d32f2f' : '#000000'}
            variant='h4'
            fontSize={'18px'}
            fontWeight={700}
          >
            {tenantRemainLicense}
          </Typography>
        </Box>
      </Box>
    )}
   </Grid>

    <Grid item xs={12} >
    <Box width={'400px'} height={'28px'} margin={2} bgcolor={'#00387C'} borderRadius={1}>
    <Typography fontSize={'16px'} color={'white'} marginTop={5} textAlign={'center'}>
     پیشنهاد/ درخواست ارسالی بررسی نشده: {CooperateData?.createByMy?.length}
    </Typography>
    </Box>
    <Grid item xs={12}>
        {
       CooperateData?.createByMy?.length===0 && <Grid item xs={12}>
         <Box width={'100%'} textAlign={'center'} p={2}   >
           <Box>
             <Typography textAlign={'center'} fontWeight={500} fontSize={'18px'} variant='body2'   >
              پیشنهاد/ درخواست های ارسال شده در این دوره‌‌زمانی وجود ندارد.
             </Typography>
           </Box>
         </Box>
       </Grid>
       }

        </Grid>
     <Grid item xs={12}   >
         <Grid container spacing={0.5} px={1} >
          {
            CooperateData?.createByMy?.length > 3 ?
            <CoopSlider
            keyresultData={CooperateData?.createByMy}
            setKrId={CooperateData?.createByMy[0]?.keyResultId} 
            meetingId={CooperateData?.createByMy[0]?.meetingId}
            setShowToastMessage={setShowToastMessage}
            personPicture={personPicture}
            />
         :
         CooperateData?.createByMy && CooperateData?.createByMy?.map((o:any,i:number)=>{
           return <Grid  item xs={12} sm={4}  >
            <Box width={'100%'} key={i}   >
            <SubAlignmentKrCart
                setKrId={CooperateData?.createByMy[0]?.keyResultId} 
                meetingId={CooperateData?.createByMy[0]?.meetingId}
                setShowToastMessage={setShowToastMessage}
                personPicture={personPicture}
                item={o}
                />
          </Box>
          </Grid>
        })
      }
        </Grid> 
       </Grid>
       {
          showEditObjective  &&  <ModalLyt
            showModal={showEditObjective}
            setShowModal={setShowEditObjective}
            width={isMobile ? '350px' : '900px'} 
            height={900}
            title={"ویرایش هدف"}
          >
          {
             showEditObjective  && <EditObjective
              periodsData={periodsData}
              onSuccess={setShowEditObjective}
              setShowToastMessage={setShowToastMessage}
              setObjectiveAsyncOpState={getObjectivesAgain}
              afterSuccess={setShowEditObjective}
              objectiveId={objectiveId}
              periodId={periodId}
              onClose={setShowEditObjective}
              setEditObjectiveState={getObjectivesAgain}
            />
          }
          </ModalLyt>
        }
    </Grid>

   <Grid item xs={12} >
    <Box width={'400px'} height={'28px'} margin={2} bgcolor={'#00387C'} borderRadius={1}>
    <Typography fontSize={'16px'} color={'white'} marginTop={5} textAlign={'center'}>
     پیشنهاد/ درخواست دریافتی بررسی نشده: {CooperateData?.receiveToMy?.length}
    </Typography>
    </Box>
    <Grid item xs={12}>
        {
       CooperateData?.receiveToMy?.length === 0 && <Grid item xs={12}>
         <Box width={'100%'} textAlign={'center'} p={2}   >
           <Box>
             <Typography textAlign={'center'} fontWeight={500} fontSize={'18px'} variant='body2'   >
             پیشنهاد/ درخواست های دریافت شده در این دوره‌‌زمانی وجود ندارد.
             </Typography>
           </Box>
         </Box>
       </Grid>
       }

        </Grid>
        <Grid item xs={12}   >
         <Grid container spacing={0.5} px={1} >
         {
          CooperateData?.receiveToMy?.length > 3 ?
          <CoopSlider
            keyresultData={CooperateData?.receiveToMy}
            setKrId={CooperateData?.createByMy[0]?.keyResultId} 
            meetingId={CooperateData?.receiveToMy[0]?.meetingId}
            setShowToastMessage={setShowToastMessage}
            personPicture={personPicture}
         /> :
         CooperateData?.receiveToMy && CooperateData?.receiveToMy?.map((o:any,i:number)=>{
          return <Grid  item xs={12} sm={4}  >
            <Box width={'100%'} key={i}   >
            <SubAlignmentKrCart
                setKrId={CooperateData?.createByMy[0]?.keyResultId} 
                meetingId={CooperateData?.receiveToMy[0]?.meetingId}
                setShowToastMessage={setShowToastMessage}
                personPicture={personPicture}
                item={o}
                />
          </Box>
          </Grid>
        })
         }
        </Grid> 
       </Grid>
       {
          showEditObjective  &&  <ModalLyt
            showModal={showEditObjective}
            setShowModal={setShowEditObjective}
            width={isMobile ? '350px' : '900px'} 
            height={900}
            title={"ویرایش هدف"}
          >
          {
             showEditObjective  && <EditObjective
              periodsData={periodsData}
              onSuccess={setShowEditObjective}
              setShowToastMessage={setShowToastMessage}
              setObjectiveAsyncOpState={getObjectivesAgain}
              afterSuccess={setShowEditObjective}
              objectiveId={objectiveId}
              periodId={periodId}
              onClose={setShowEditObjective}
              setEditObjectiveState={getObjectivesAgain}
            />
          }
          </ModalLyt>
        }
    </Grid>

    <Box width={'98px'}  height={'28px'} margin={2}  justifyContent={'center'} bgcolor={'#00387C'} borderRadius={1}>
    <Typography textAlign={'center'} fontSize={'16px'} color={'white'} >
      جلسات اخیر
    </Typography>
   </Box>
    <Grid container xs={12} >
    <Grid container xs={8} >
    {existData &&
     existData?.slice(0, 2).map((data: any, i: number): any => {
      return (
        <Box width={'50%'} key={i} px={1}>
            <MeetingCard
              setMeetId={setMeetId}
              info={data}
              prog={i}
              accessForReport={accessForReport}
              bank={bank}
              setShowDownlodLink={setShowDownlodLink}
              setPMeetingId={setMeetingId}
              setshowEditMeeting={setshowEditMeeting}
              showEditMeeting={showEditMeeting}
              setShowToastMessage={setShowToastMessage}
              setDeleteMeetState={setMeetingAsyncState}
            />
        </Box>
      );
    })}
     {
      existData?.length === 0 && <Box sx={{ display: 'flex',alignItems:'center',justifyContent:'center',height:'100%',width:'100%' }}>
        <Grid item xs={12}>
         <div className="w-full flex justify-center">
          <Typography fontSize={20}>
            {/* <AddMeetingVector
              style={{
                width: "300px",
                height: "100%",
                alignSelf: "center",
                textAlign: "center",
              }}
              /> */}
                در این دوره جلسه ایی وجود ندارد
              </Typography>
              </div>
        </Grid>
      </Box>
    } 
     </Grid>
     <Grid xs={4} >
   <Box display={'flex'} justifyContent={'start'}>
      <Swiper
        spaceBetween={10}
        slidesPerView={1}
        breakpoints={{
          600: {
            slidesPerView: 2, 
          },
        }}
        style={{ width: "100%", height: 250 }}
      >
        <SwiperSlide>
          <Box display="flex" flexDirection="column" alignItems="center" marginRight={4}>
            <GaugeChart value={dashBoardData?.evaluation} label={label1} sections={sections} />
          </Box>
        </SwiperSlide>
        <SwiperSlide>
          <Box display="flex" flexDirection="column" alignItems="center" marginRight={4}>
            <GaugeChart value={dashBoardData?.score} label={label2} sections={sections} />
          </Box>
        </SwiperSlide>
      </Swiper>
    </Box>
    </Grid>
    </Grid>

    <Grid item xs={12} >
    <Box width={'98px'} height={'28px'} margin={2} bgcolor={'#00387C'} borderRadius={1}>
    <Typography fontSize={'16px'} color={'white'} marginTop={5} textAlign={'center'}>
      اهداف من
    </Typography>
    </Box>
    <Grid item xs={12}>
        {
       allObjective?.length===0 && <Grid item xs={12}>
         <Box width={'100%'} textAlign={'center'} p={2}   >
           <Box>
             <Typography textAlign={'center'} fontWeight={500} fontSize={'18px'} variant='body2'   >
               هدفی در این دوره‌‌زمانی تعریف نشده است.
             </Typography>
           </Box>
         </Box>
       </Grid>
       }

        </Grid>
     <Grid item  xs={12}   >
         <Grid container spacing={0.5} px={1} >
          {
            allObjective?.length != undefined && allObjective?.length > 3 ?
            <OSlider
            keyresultData={allObjective}
            setShowToastMessage={setShowToastMessage}
            allObjective={allObjective}
            setObjectiveId={setObjectiveId}
            personPicture={personPicture}
            setShowEditForm={setShowEditObjective}
            setObjectiveAsyncOpState={
              setObjectiveAsyncOpState
            }
            />
            :
            allObjective && allObjective.map((o:any,i:number)=>{
              return <Grid  item xs={12} sm={4}  >
                <Box width={'100%'} key={i}   >
                <OCart
                    obj={o}
                    setShowToastMessage={setShowToastMessage}
                    afterSuccess={allObjective}
                    setObjectiveId={setObjectiveId}
                    item={o}
                    personPicture={personPicture}
                    setShowEditForm={setShowEditObjective}
                    setObjectiveAsyncOpState={
                        setObjectiveAsyncOpState
                    }
                    />
              </Box>
              </Grid>
          })
        }
        </Grid> 
       </Grid>
       {
          showEditObjective  &&  <ModalLyt
            showModal={showEditObjective}
            setShowModal={setShowEditObjective}
            width={isMobile ? '350px' : '900px'} 
            height={900}
            title={"ویرایش هدف"}
          >
          {
             showEditObjective  && <EditObjective
              periodsData={periodsData}
              onSuccess={setShowEditObjective}
              setShowToastMessage={setShowToastMessage}
              setObjectiveAsyncOpState={getObjectivesAgain}
              afterSuccess={setShowEditObjective}
              objectiveId={objectiveId}
              periodId={periodId}
              onClose={setShowEditObjective}
              setEditObjectiveState={getObjectivesAgain}
            />
          }
          </ModalLyt>
        }
    </Grid>

    <Grid item xs={12} >
    <Box width={'98px'} margin={2} justifyContent={'center'}  height={'28px'}  bgcolor={'#00387C'} borderRadius={1}>
    <Typography fontSize={'16px'}  color={'white'} marginTop={5} textAlign={'center'} >
      نتایج کلیدی من
    </Typography>
    </Box>
    <Grid item xs={12}>
        {
       keyresultData?.length===0 && <Grid item xs={12}>
         <Box width={'100%'} textAlign={'center'} p={2}   >
           <Box>
             <Typography textAlign={'center'} fontWeight={500} fontSize={'18px'} variant='body2'   >
               نتیجه کلیدی در این دوره‌‌زمانی تعریف نشده است.
             </Typography>
           </Box>
         </Box>
       </Grid>
       }
        </Grid>
     <Grid item xs={12}  >
         <Grid container spacing={1} px={1} >
          {
            keyresultData?.length !== undefined && keyresultData?.length > 3 ?
           <OKRsSlider
              keyresultData = {keyresultData}
              setKrId={setKrId} 
              setShowEditKr={setShowEditKr}  
              setShowToastMessage={setShowToastMessage}
              afterSuccess={keyresultData}
              personPicture={personPicture}
              setObjectiveId={setObjectiveId}
              setIteam={setIteam}
              setObjectiveAsyncOpState={
                setObjectiveAsyncOpState
              }
            />
         :
          keyresultData && keyresultData?.map((o:any,i:number)=>{
              return <Grid  item xs={12} sm={4}  >
                <Box width={'100%'} key={i}   >
                <OKRsCart
                     setKrId={setKrId}
                     setShowEditKr={setShowEditKr}
                     setShowToastMessage={setShowToastMessage}
                     afterSuccess={keyresultData}
                     personPicture={personPicture}
                     setObjectiveId={setObjectiveId}
                     item={o}
                     setIteam={setIteam}
                     setObjectiveAsyncOpState={setObjectiveAsyncOpState}
                    />
              </Box>
              </Grid>
          })
        }
        </Grid> 
       </Grid>
    </Grid>
          {
            showToastMessage && <DYToastMessage
            setShow={setShowToastMessage}
            show={showToastMessage}
              />
          }
          {
              showEditKr && <ModalLyt 
              showModal={showEditKr}
              setShowModal={setShowEditKr}
              title={'ویرایش نتیجه کلیدی'}
              >
              <EditKeyResult
              definitionId = {""}
              setShowEditKeyResult={setShowEditKr}
              editKrSuccess={getObjDataAgain}  
              setShowToastMessage={setShowToastMessage}
              setAddKrState={setAddKrState}
              setShowToastMessage3={setShowToastMessage3}
              krId={krId}
              Item={Item}
          />
          </ModalLyt>
        }
    </Grid>
     {showToastMessage3 && (
          <DYToastMessage
            isSuccess={true}
            message={'عملیات با موفقیت انجام شد'}
            setShow={setShowToastMessage3}
            show={showToastMessage3}
          />
        )}
    </Grid>

      {showDownloadLink && (
        <ModalLyt
          showModal={Boolean(showDownloadLink)}
          setShowModal={setShowDownlodLink}
        >
          <Box width={"100%"} alignItems={"center"}>
            <Link
              target="_blank"
              to={`${baseUrl}Download/ExportMeetingDetails?meetingId=${meetId}`}
            >
              دریافت فایل
            </Link>
          </Box>
        </ModalLyt>
      )}

      {showEditMeeting && (
        <ModalLyt 
          showModal={showEditMeeting} 
          setShowModal={setshowEditMeeting}           
          width={isMobile ? '350px' : '900px'}  
        >
          <EditMeeting
            meetingId={meetingId}
            hideModal={setshowEditMeeting}
            setMeetingAsyncState={setMeetingAsyncState}
            setShowToastMessage={setShowToastMessage}
            profileTenantId={profileTenantId}
          />
        </ModalLyt>
      )}
      
      {showToastMessage && (
        <DYToastMessage
          isSuccess={meetingAsyncState?.isSuccess}
          message={meetingAsyncState?.metaData.message}
          setShow={setShowToastMessage}
          show={showToastMessage}
        />
      )}
      {showToastMessage2 && (
          <DYToastMessage
            isSuccess={true}
            message={'عملیات با موفقیت انجام شد'}
            setShow={setShowToastMessage2}
            show={showToastMessage2}
          />
        )}
    </Grid>
  );
};
  
  export default AllTenantDash